import { useReportContext } from "../../../../context/report_context";
import ReportOverview from "../ReportOverview";

const BusinessReportOverview = () => {

      const { businessOverview, isFetching } = useReportContext();

      const overview = [
            { amount: businessOverview?.profit, title: 'Total Profit', color: '#E2B581', isNumber: true },
            { amount: businessOverview?.revenue, title: 'Revenue', color: '#448DF2', isNumber: true },
            { amount: 0, title: 'Sales', color: '#845EBC', isNumber: true },
            { amount: businessOverview?.expenses, title: 'Expenses', color: '#FF0000CC', isNumber: true },
            { amount: businessOverview?.qty, title: 'Total Quantity', color: '#441123CC', isNumber: false },
            { amount: businessOverview?.net_profit, title: 'Net Profit', color: '#667085', isNumber: true },
            { amount: businessOverview?.net_sales, title: 'Net Sales', color: '#667085', isNumber: true },
            { amount: 0, title: 'Total Debt', color: '#667085', isNumber: true },
            { amount: 0, title: 'Total Credit', color: '#667085', isNumber: true },
      ];


      return (
            <div>

                  <ReportOverview
                        overview={overview}
                        loading={isFetching}
                  />
            </div>
      );
};

export default BusinessReportOverview;